import { FormQuestionType } from '@televet/shared-types';
import React, { ReactElement } from 'react';
import Prompt, { ElementType } from '../Prompt';
import { IFromDraftCommonProps } from '../Question';
import QuestionHeader from '../QuestionHeader';
import RequiredSelector from './RequiredSelector';

interface IFormInputProps extends IFromDraftCommonProps {
  questionType: FormQuestionType;
}

const FormInput = ({ index, prompt, isRequired, lastIndex, questionType }: IFormInputProps): ReactElement => {
  return (
    <>
      <QuestionHeader index={index} questionType={questionType} lastIndex={lastIndex} />
      <Prompt
        index={index}
        prompt={prompt}
        refType={questionType === 'textBlock' ? ElementType.textArea : ElementType.input}
      />
      {questionType !== 'textBlock' && <RequiredSelector index={index} isRequired={isRequired} />}
    </>
  );
};

export default FormInput;
